export const LANDING_PAGE_JOIN_API_PATH = '/api/join';
